<template>
  <div id="article5" class="area">
    <h2><span style="margin-right: 0.5em">台北101年省「四口之家14年用水量」</span>遠百平均每日省下近50噸水</h2>
    <p>在降雨豐沛的年度，台北101可藉由雨水回收系統，節省至多5萬噸用水，約等同於4口之家14年的用水量。遠東百貨也透過雨水回收系統、空調用水調節等方式節水，平均每日可省下近50噸水。</p>
    <div class="content">
      <div class="imgbox">
        <img src="../../assets/images/tp-101.png" style="position: relative; z-index: 1;" alt="">
        <img
          class="imgbox-animate" 
          src="../../assets/images/tp-101-5.png"
          data-aos="fade"
          data-aos-duration="1000"
          data-aos-delay="500"
          alt=""
        >
        <img
          class="imgbox-animate" 
          src="../../assets/images/tp-101-4.png"
          data-aos="fade-down"
          data-aos-duration="500"
          data-aos-delay="0"
          alt=""
        >
        <img
          class="imgbox-animate" 
          src="../../assets/images/tp-101-3.png"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-delay="1500"
          alt=""
        >
        <img
          class="imgbox-animate" 
          src="../../assets/images/tp-101-2.png"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-delay="1000"
          alt=""
        >
      </div>
    </div>
    <div class="readmore" style="text-align: right;">
      <a href="https://pse.is/38pruc" target="_blank">詳全文>></a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.imgbox {
  position: relative;
  padding: 1em;
  background: rgba(255, 255, 255, .8);
}
.imgbox-animate {
  position: absolute;
  top: 1em;
  left: 1em;
  width: calc(100% - 2em);
}
</style>
